module.exports = __webpack_public_path__ + "static/media/05_profile_picture.bc859f82.png";